module.exports = __webpack_public_path__ + "static/media/downloadbannergif.fa32a7ca.gif";